import styled from "styled-components";
import { Pagination as MuiPagination } from "@mui/material";
import { colors } from "../pages/css components/Style";

const BasicPagination = styled(MuiPagination)`
  & ul {
    & .MuiPaginationItem-root {
      color: ${colors.iconColor};
      height: 35px;
      width: 35px;
      font-size: 15px;
      border-radius: 9px;
      border: 1px solid ${colors.iconColor};

      &:hover {
        background: #32bcad2e;
      }
    }
  }

  & .Mui-selected {
    color: white !important;
    background-color: ${colors.iconColor};
  }
`;

export default function Pagination(props) {
  return <BasicPagination shape="rounded" {...props} />;
}
